import { Button, Stack } from '@mui/material'
import { NavLink } from 'react-router-dom'
import { ROUTES_PATH_PARTS } from '@/constants'
import { useTranslation } from 'react-i18next'
import { Project, UserGroups } from '@/types'
import { AuthorizationGuard } from '@/components'
import { faMap } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

type ProjectDetailNavigationProps = {
  project?: Project
}

export const ProjectDetailNavigation = ({
  project,
}: ProjectDetailNavigationProps): JSX.Element => {
  const { t } = useTranslation('projects')

  return (
    <Stack
      direction="row"
      pb={5}
      spacing={2}
      sx={{
        a: { color: 'text.primary' },
        'a.active': {
          fontWeight: 700,
          bgcolor: 'secondary.light',
        },
      }}
    >
      <Button
        variant="text"
        color="secondary"
        size="small"
        component={NavLink}
        to="."
        end={true}
      >
        {t('detailLinks.projectInfo')}
      </Button>

      <AuthorizationGuard allowedGroups={[UserGroups.MANAGER]} redirect={false}>
        <Button
          variant="text"
          color="success"
          size="small"
          component={NavLink}
          to={ROUTES_PATH_PARTS.PLANNING}
        >
          {t('detailLinks.planning')}
        </Button>
      </AuthorizationGuard>

      {project && !!project.gis_map && (
        <Button
          variant="text"
          color="primary"
          size="small"
          component={NavLink}
          to={ROUTES_PATH_PARTS.MAP}
          startIcon={<FontAwesomeIcon icon={faMap} />}
        >
          {t('detailLinks.map')}
        </Button>
      )}
    </Stack>
  )
}
